<div class="card">
    <div class="card-header">
        <h4>{{ 'MY_ASSETS' | translate}}</h4>
    </div>
    <div class="card-body">
        <div *ngIf="myAssets?.length < 1">{{'YOU_HAVE_NO_ASSET' | translate}}</div>
        <div *ngFor="let asset of myAssets" class="row mb-1">
            <div class="col-12">
                <span [class]="'font-weight-medium text-break-line-1 mb-0 text-' + (asset.inMaintenance ? 'danger' : '')" [ngbTooltip]="asset.inMaintenance ? ('IN_MAINTENANCE' | translate) : null" placement="left">
                    {{asset.name}}
                </span>
                <small>
                    {{'ASSIGN_MALE' | translate}}: {{_utilsService.formatDate(asset.start_date)}}
                </small>
            </div>
        </div>
    </div>
</div>